import { relations } from 'drizzle-orm';
import { index, integer, pgTable, serial, uniqueIndex, varchar } from 'drizzle-orm/pg-core';
import { user } from './user';

export const SOCIAL_AUTH_PROVIDERS = ['github', 'google'] as const;

export const userIdentity = pgTable(
  'user_identity',
  {
    id: serial().primaryKey(),
    provider: varchar({ length: 50 }).notNull().$type<(typeof SOCIAL_AUTH_PROVIDERS)[number]>(),
    account_email: varchar({ length: 320 }),
    provider_user_id: varchar({ length: 255 }).notNull(),
    provider_user_name: varchar({ length: 255 }),
    user_id: integer()
      .notNull()
      .references(() => user.id, { onDelete: 'cascade' }),
  },
  (t) => [
    uniqueIndex('user_identity_provider_provider_user_id_uq').on(t.provider, t.provider_user_id),
    index('user_identity_user_id_idx').on(t.user_id),
    index('user_identity_user_provider_idx').on(t.user_id, t.provider),
  ],
);

export const userSocialAuthIdentityRelations = relations(userIdentity, ({ one }) => ({
  user: one(user, { fields: [userIdentity.user_id], references: [user.id] }),
}));
